__turbopack_context__.v({
  "ctaContainer": "AccountLockingDialogContent-module__flPGLq__ctaContainer",
  "link": "AccountLockingDialogContent-module__flPGLq__link",
});
